import {Alcance} from './alcance.model';
import {Projeto} from './projeto.model';

export class ProjetoAlcance {

  id: number;
  projeto: Projeto;
  alcance: Alcance;

  constructor(init?: Partial<ProjetoAlcance>) {
    Object.assign(this, init);
  }
}
